<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="12"
      >
        <b-card title="Sertifika Yükle">
          <pre-loading v-if="uploading" />
          <template v-else>
            <b-embed
              v-if="itemData.file"
              type="iframe"
              aspect="4by3"
              :src="baseURL + '/media/certificates/' + itemData.file"
              allowfullscreen
            />
            <b-form-file
              id="desktop-video"
              v-model="desktop_video"
              class="mt-1"
              placeholder="Bir dosya seçin veya buraya bırakın..."
              drop-placeholder="Dosyayı buraya bırakın..."
              browse-text="Dosya Seçin"
            />
            <div class="mt-1">
              <b-button
                variant="primary"
                :disabled="!desktop_video"
                @click="uploadFile('desktop')"
              >
                <FeatherIcon icon="UploadIcon" />
                Dosya Yükle
              </b-button>
            </div>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BButton, BCard, BCol, BRow, BFormFile, BEmbed,
} from 'bootstrap-vue'
import PreLoading from '@/layouts/components/common/PreLoading.vue'

export default {
  name: 'FileCard',
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
    BFormFile,
    BEmbed,
    PreLoading,
  },
  data() {
    return {
      baseURL: this.$store.state.app.baseURL,
      desktop_video: null
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['certificates/dataItem']
    },
    uploading() {
      return this.$store.getters['fileUpload/uploading']
    },
  },
  methods: {
    uploadFile(type) {
      let file = ''
      if (type === 'desktop') {
        file = this.desktop_video
      }
      this.$store.dispatch('fileUpload/uploadFile', {
        upload_file: file,
        folder: 'certificates',
      })
        .then(response => {
          if (response.filename) {
            if (type === 'desktop') {
              this.itemData.file = response.filename
            }
          }
        })
    },
  },
}
</script>
